import {Modal, Space, Table} from "antd";
import React, {useEffect, useState} from "react";
import {HttpService} from "../../../services/http/Http.service";
import Title from "antd/es/typography/Title";
import {UtilsService} from "../../../services/Utils.service";
import {FileTs} from "../../../model/models";
import {HttpErrorService} from "../../../services/http/HttpError.service";
import {detailModalColumns} from "./DetailModalColumns";

interface DetailModalProps {
    isOpen?: boolean,
    setIsOpen?: (value: (((prevState: boolean) => boolean) | boolean)) => void,
    combinatorId?: string | undefined,
    userId?: number,
    setUserId?: (value: (((prevState: (number | undefined)) => (number | undefined)) | number | undefined)) => void,
    username?: string,
    fiscalCode?: string,
    type?: string,
    isRateApplied?: boolean
}

interface Installment {
    id: number,
    order?: number,
    simulatorId: number,
    personId: number,
    total: number,
    totalSpese: number,
    totalSanzione: number,
    deadline: string,
    installmentRate: number,
    dateOfPayment?: string,
    uniquePayment: true
}


export default function DetailModal({
                                        isOpen,
                                        setIsOpen,
                                        combinatorId,
                                        userId,
                                        setUserId,
                                        username,
                                        fiscalCode,
                                        type,
                                        isRateApplied
                                    }: DetailModalProps) {

    const [listOfPractices, setListOfPractices] = useState<FileTs[]>([])
    const [totalSanction, setTotalSanction] = useState<number>(0)

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                if (isOpen && combinatorId && userId !== undefined) {
                    HttpService.getInstanceAxios()
                        .get(`/simulazione/${combinatorId}/person/${userId}`)
                        .then(response => {
                            const practices = response.data;
                            const totalSanctionSum = practices.reduce(
                                (acc: number, item: any) => acc + (item.totalSanction || 0),
                                0
                            );
                            setListOfPractices(practices);
                            setTotalSanction(totalSanctionSum);
                        });
                }
            } catch (error) {
                HttpErrorService.handle("Errore durante il recupero dei dettagli della pratica", error, true)
            }
        }
        fetchDetails()

    }, [isOpen, combinatorId, userId]);

    const [listOfInstallements, setListOfInstallements] = useState<Installment[]>([])
    useEffect(() => {
        const fetchInstallmentDetails = async () => {
            try {
                if (isRateApplied && isOpen && combinatorId && userId !== undefined) {
                    HttpService.getInstanceAxios().get(`/installment/simulator/${combinatorId}/person/${userId}`)
                        .then(response => {
                            setListOfInstallements(response.data)
                        })
                }
            } catch (error) {
                HttpErrorService.handle("Errore durante il recupero dei dettagli della pratica", error, true)
            }
        }
        fetchInstallmentDetails()

    }, [isOpen, combinatorId, userId]);

    const handleCancel = () => {
        if (setIsOpen) {
            setIsOpen(false);
        }
        if (setUserId) {
            setUserId(undefined)
        }
    };

    const columnsRate = [
        {
            title: "Rata",
            dataIndex: "order",
            key: "order",
        },
        {
            title: "Importo",
            key: "total",
            render: (record: Installment, _: any) => {
                return `€ ${UtilsService.formatNumber(record.total)}`;
            }
        },
        {
            title: "Scadenza",
            key: "deadline",
            render: ((record: Installment) => record.deadline !== null ? UtilsService.formatDateString(record.deadline) : "-")
        },
        {
            title: "Pagata",
            key: "paid",
            render: ((record: Installment) => record.dateOfPayment ? "Si" : "No")
        },
        {
            title: "Data di pagamento",
            key: "paymentDate",
            render: ((record: Installment) => record.dateOfPayment ? UtilsService.formatDateString(record.dateOfPayment) : "-")
        },
    ];


    const [expenses, setExpenses] = useState<number>(0)
    useEffect(() => {
        const fetchExpenses = async () => {
            try {
                const data = await HttpService.getInstanceAxios().get(`/spesePratica/getImportoSpesaByFileType/${type}`)
                setExpenses(data.data)
            } catch (error) {
                HttpErrorService.handle("Errore durante il recupero del valoro delle spese", error, true)
            }
        }
        fetchExpenses()
    }, []);

    return (
        <>
            <Modal open={isOpen} footer={null} onCancel={handleCancel} width={"fit-content"}>
                <Space size={"middle"} direction={"vertical"}>
                    <div><Title level={4}>Dettaglio</Title></div>
                    <div><strong>Nome Cognome: </strong>{username}</div>
                    <div><strong>Codice Fiscale: </strong>{fiscalCode}</div>
                    <Table<FileTs>
                        rowKey={"id"}
                        columns={detailModalColumns}
                        style={{width: "auto"}}
                        dataSource={listOfPractices}
                        pagination={false}
                        summary={(data) => {
                            const totalSum = data.reduce((sum, record) => sum + (record.totalTicket || 0), 0);
                            const totalInterests = data.reduce(
                                (sum, record) => sum + (record.totalInterest ? record.totalInterest : 0),
                                0
                            );
                            const grandTotal = totalSum + totalInterests

                            return (
                                <>
                                    <Table.Summary.Row style={{backgroundColor: "#f0f0f0"}}>
                                        <Table.Summary.Cell index={0}>Spese amministrative</Table.Summary.Cell>
                                        <Table.Summary.Cell index={1}/>
                                        <Table.Summary.Cell index={2}/>
                                        <Table.Summary.Cell index={3}/>
                                        <Table.Summary.Cell
                                            index={4}>€ {UtilsService.formatNumber(expenses)}</Table.Summary.Cell>
                                    </Table.Summary.Row>
                                    <Table.Summary.Row style={{backgroundColor: "#f0f0f0"}}>
                                        <Table.Summary.Cell index={0}>Sanzione</Table.Summary.Cell>
                                        <Table.Summary.Cell index={1}/>
                                        <Table.Summary.Cell index={2}/>
                                        <Table.Summary.Cell index={3}/>
                                        <Table.Summary.Cell
                                            index={4}>€ {UtilsService.formatNumber(totalSanction)}</Table.Summary.Cell>
                                    </Table.Summary.Row>
                                    <Table.Summary.Row style={{backgroundColor: "#e8e8e8"}}>
                                        <Table.Summary.Cell index={0}>Riepilogo (rata unica) </Table.Summary.Cell>
                                        <Table.Summary.Cell index={2}></Table.Summary.Cell>
                                        <Table.Summary.Cell
                                            index={2}>€ {UtilsService.formatNumber(totalSum)}</Table.Summary.Cell>
                                        <Table.Summary.Cell
                                            index={4}>{totalInterests !== 0 ? ("€ " + UtilsService.formatNumber(totalInterests)) : "No"}</Table.Summary.Cell>
                                        <Table.Summary.Cell
                                            index={5}>€ {UtilsService.formatNumber(grandTotal + expenses + totalSanction)}</Table.Summary.Cell>
                                    </Table.Summary.Row>

                                </>
                            );
                        }}
                    />
                    {isRateApplied &&
                        <>
                            <div><Title level={4}>Dettaglio rate</Title></div>
                            <Table
                                columns={columnsRate}
                                style={{width: "auto"}}
                                pagination={false}
                                dataSource={listOfInstallements.slice(0, -1)} //Do not show the last unique payment
                                rowKey="id"
                            />
                        </>
                    }
                </Space>
            </Modal>
        </>
    )
}